/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'vehicle': {
    width: 11,
    height: 9,
    viewBox: '0 0 11 9',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd"><path pid="0" d="M.83 4.241v2.376H1.7M3.357 6.644h3.879M8.891 6.639h.841V4.117L8 1.43H6.5V.814H.84v.984M6 3.25h3.5"/><ellipse pid="1" _fill="#FFF" cx="7.317" cy="6.345" rx="1.317" ry="1.345"/><ellipse pid="2" _fill="#FFF" cx="3.315" cy="6.342" rx="1.315" ry="1.342"/><path pid="3" d="M.83 4.241v2.376H1.7M3.357 6.644h3.879M8.891 6.639h.841V4.117L8 1.43H6.5V.814H.84v.984M6 3.25h3.5"/><ellipse pid="4" _fill="#FFF" cx="7.317" cy="6.345" rx="1.317" ry="1.345"/><ellipse pid="5" _fill="#FFF" cx="3.315" cy="6.342" rx="1.315" ry="1.342"/></g>'
  }
})
